import { Theme } from "theme-ui";
const isWindows = typeof window !== 'undefined' && (navigator.platform.indexOf('Win') > -1);
const isLinux = typeof window !== 'undefined' && (navigator.platform.indexOf('Linux') > -1);

const theme: Theme = {
  breakpoints: ["640px", "832px", "1024px", "1280px", "1440px"],
  space: [0, 8, 12, 16, 18, 24, 32, 40, 64, 128, 256],
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64],
  sizes: [0, 8, 16, 32, 64, 128, 256],
  initialColorModeName: 'light',
  colors: {
    text: '#C3ACD0',
    background: '#fff',
    primary: '#7743DB',
    secondary: '#0A0A0A',
    InactiveBorder: "#F7EFE5",
    lightbackground: "#F7EFE5",
    ActiveBorder: '#7743DB',
    muted: ' #8F9195',
    grey: "#8D8D8D",
    lightgray: "#CCCCCC",
    brown: '#453521',
    lightbrown: '#C4AF95',
    danger: "#E54141",
    green: "green",
    musterd: "#CA8A04",
    warning: "#eac42a",
    white: '#FDFDFD',
    black: '#000',
    transparent: "transparent",
    red: "#FF0000",
    salmon: "#FF8484",
    whitesmoke: "#F6F6F6",
    modes: {
      dark: {
        text: '#E3E3E3',
        background: '#20283c',
        primary: '#BB86FC',
        secondary: '#dce2e882',
        InactiveBorder: "#334758ff",
        lightbackground: "#1F1F1F",
        ActiveBorder: '#BB86FC',
        muted: '#9E9E9E',
        grey: "#616161",
        danger: "#CF6679",
        green: "#03DAC6",
        musterd: "#FBC02D",
        warning: "#FFB300",
        white: '#F5F5F5',
        black: '#121212',
        red: "#CF6679",
        whitesmoke: "#212121",
      }
    }

  },
  forms: {
    Checkbox: {
      border: '1px solid #7743DB',
      background: '#8d8d8d'
    },
    Textarea: {
      borderColor: '#F7EFE5',
    },
    FilterModal: {
      boxShadow: '0px 1px 2px 0px rgba(0, 0, 0, 0.05)',
      border: '1px solid #F7EFE5',
      borderRadius: 12,
      backgroundColor: "white",
      p: 3,
      outline: 'none'

    },
    UploadLabel: {
      cursor: 'pointer',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '8px',
      padding: '10px 16px',
      color: '#6366f1',
      borderRadius: '8px',
      fontSize: '14px',
      fontWeight: 500,
      transition: 'background 0.2s',
      width: 'fit-content',
      margin: '0 auto',
      '&:hover': {
        background: 'rgba(99, 102, 241, 0.22)'
      }
    }
  },

  fonts: {
    body: 'Poppins',
    heading: 'Poppins',
    poppins: "Poppins"
  },
  text: {
    SelectLabel: {
      color: '#0A0A0A',
      fontFamily: "Poppins",
      fontSize: [12, 12, 12, 13, 14, 14],
      fontWeight: "500",
      lineHeight: "50px"
    },
    activityText: {
      color: '#8F9195',
      fontFamily: 'Poppins',
      fontSize: '12px',
      fontWeight: '400',
      lineHeight: '140%',
      fontStyle: 'normal',
      display: 'block',
      padding: '12px 10px',
      alignSelf: 'stretch',
      borderRadius: '12px',
      border: '0.5px solid var(--light-color, #F7EFE5)',
      whiteSpace: 'pre-line',
      wordBreak: 'break-word',
      overflowWrap: 'anywhere'
    },
    expandableComment: {
      fontSize: '12px',
      lineHeight: 1.4,
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      wordBreak: 'break-all',
      overflowWrap: 'anywhere',
      whiteSpace: 'pre-wrap',
    },
    SenderName: {
      fontFamily: 'poppins',
      fontSize: '16px',
      fontWeight: '500',
      lineHeight: '24px',
      letterSpacing: '0em',
      textAlign: 'left'
    },
    tableHeading: {
      color: '#020202',
      fontFamily: 'poppins',
      fontSize: 36,
      fontWeight: 600
    },
    Poppins16Normal25lh: {
      color: 'secondary',
      fontSize: 14,
      fontFamily: 'poppins',
      fontWeight: 500,
      lineHeight: '156.25%',
      textAlign: 'center',
      textTransform: 'capitalize'
    },
    Poppins14Normal24lh: {
      color: 'muted',
      fontSize: 14,
      fontFamily: 'poppins',
      fontWeight: 400,
      lineHeight: '171%',
      textAlign: 'center',
    },
    Poppins15Normal24lh: {
      color: 'muted',
      fontSize: 15,
      fontFamily: 'poppins',
      fontWeight: 500,
      lineHeight: '171%',
      textAlign: 'center',
    },
    Poppins16Bold16lh: {
      fontSize: [12, 13, 15, 16],
      fontFamily: 'poppins',
      lineHeight: '16px',
      fontWeight: 600
    },
    Poppins14Medium20lh: {
      fontSize: [12, 13, 14, 14],
      fontWeight: 500,
      lineHeight: '20px',
      fontFamily: 'poppins'
    },
    Poppins14Normal: {
      color: 'grey',
      fontSize: 14,
      fontFamily: 'poppins',
      fontWeight: 400,
      lineHeight: 'normal',
      textAlign: 'center',
    },
    Poppins16Bold: {
      color: '#FF8C00',
      fontSize: 15,
      fontFamily: 'poppins',
      fontWeight: 500,
      lineHeight: 'normal',
      textAlign: 'left',
    },
    Poppins36Normal35lh: {
      // color: 'secondary',
      fontFamily: 'poppins',
      fontSize: [24, 28, 30, 32, 32],
      fontWeight: 600,
      lineHeight: '100%',
      textTransform: 'capitalize'
    },
    Poppins30Normal35lh: {
      color: 'secondary',
      fontFamily: 'poppins',
      fontSize: [24, 28, 30, 30, 30],
      fontWeight: 500,
      lineHeight: '100%',
      textTransform: 'capitalize'
    },

    bagde: {
      color: "#FDFDFD",
      fontSize: "12px",
      fontWeight: "400",
      lineHeight: "16px",
      fontStyle: "normal",
      fontFamily: "poppins"
    },
    UploadHint: {
      fontSize: '12px',
      color: '#8F9195'
    }
  },
  buttons: {
    SaveButton: {
      borderRadius: '12px',
      padding: '8px 45px',
      backgroundColor: '#7743db',
      color: '#fff'
    },
    CancelButton: {
      borderRadius: '12px',
      padding: '8px 45px',
      color: '#8F9195',
      border: '1px solid #8F9195',
      backgroundColor: '#fff'
    },
    LinkButton: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '4px',
      height: '22px',
      padding: '0 8px',
      fontSize: '10px',
      fontWeight: 600,
      borderRadius: '4px',
      background: 'transparent',
      textDecoration: 'none',
      whiteSpace: 'nowrap',
      cursor: 'pointer',
    },
    spentButton: {
      padding: '4px 8px 4px 8px',
      borderRadius: '12px',
      gap: '10px',
      backgroundColor: '#F7EFE5',
      border: 'none',
      color: '#7743DB'
    },
    timetrack: {
      borderRadius: '12px',
      padding: '6px 12px 6px 12px',
      gap: '8px',
      // width:'30%'
    },
    startButton: {
      borderRadius: '12px',
      padding: '6px 12px 6px 12px',
      gap: '8px',
      color: '#8F9195',
      // backgroundColor: 'white',
      border: '1px solid #8F9195',
      // width:'0%'
    },
    stopButton: {
      borderRadius: '12px',
      padding: '6px 12px 6px 12px',
      gap: '8px',
      color: '#DB4343',
      backgroundColor: 'white',
      border: '1px solid #DB4343',
    },
    sendbutton: {
      display: 'flex',
      padding: '8px',
      alignItems: 'center',
      gap: '10px',
      borderRadius: '12px',
      background: "#f7efe5"
    },
    PrimaryHeadBtn: {
      color: "#8D8D8D",
      backgroundColor: 'transparent',
      fontFamily: 'Poppins',
      borderRadius: 8,
      border: "1px solid #8D8D8D",
      fontWeight: 500,
      textAlign: "center",
      fontSize: [12, 13],
      transition: "background 0.3s",
      '&.active': {
        background: 'primary',
        color: '#fff',
        border: "1px solid #023E1A",
      },
    },
    AddManualButton: {
      backgroundColor: 'transparent',
      color: '#7743DB',
      border: '1px solid #7743DB',
      borderRadius: '8px',
      padding: '8px 16px',
      fontSize: '14px',
      fontWeight: 600,
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      gap: '6px',
      transition: 'all 0.2s ease-in-out',
      '&:hover': {
        backgroundColor: '#F3E8FF',
      },
      '[data-theme="dark"] &:hover, [theme-ui-color-mode="dark"] &:hover': {
        backgroundColor: 'rgba(119, 67, 219, 0.15)',
      },
    },
  },
  cards: {
    primary: {
      padding: 2,
      borderRadius: 4,
      boxShadow: '0 0 8px rgba(0, 0, 0, 0.125)',
      background: '#fff'
    },
    compact: {
      padding: { 2: 2, 5: 2 },
      borderRadius: 2,
      border: '1px solid',
      borderColor: 'muted',
    },
    PaginationBoredercard: {
      backgroundColor: "transparent",
      borderRadius: "8px",
      justifyContent: 'center',
      border: "1px solid",
      borderColor: 'muted',
      p: 2,
    },
    fillterCardModal: {
      // backgroundColor: 'white',
      p: 4,
      borderRadius: 12,
      border: ' 0.5px solid #F7EFE5',
      boxShadow: '0px 0px 16px 0px rgba(0, 0, 0, 0.06)'
    },
    donutChartCard: {
      padding: 0,
      borderRadius: '20px',
      boxShadow: '0 8px 24px rgba(36,28,25,0.06)',
      backgroundColor: '#FFFFFF',
      width: '100%'
    },
    donutGrid: {
      gap: [2, 3, 4],
      gridTemplateColumns: [
        'repeat(1, 1fr)',
        'repeat(2, 1fr)',
        'repeat(3, 1fr)',
        'repeat(4, 1fr)',
        'repeat(5, 1fr)'
      ],
      maxWidth: 1800,
      mx: '2px',
      px: [2, 3],
      alignItems: 'start'
    },
    uploadDropzone: {
      mt: '12px',
      border: '2px dashed rgba(255, 255, 255, 0.2)',
      borderRadius: '8px',
      padding: '20px',
      textAlign: 'center',
      backgroundColor: 'rgba(255, 255, 255, 0.02)',
      transition: 'all 0.2s ease',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '8px',
    },
    uploadDropzoneActive: {
      mt: '12px',
      border: '2px dashed #6366f1',
      borderRadius: '8px',
      padding: '20px',
      textAlign: 'center',
      backgroundColor: 'rgba(99, 102, 241, 0.1)',
      transition: 'all 0.2s ease',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '8px',
    },
    deliverTooltipWrapper: {
      position: 'relative',
      display: 'inline-block',
      '&:hover .custom-deliver-tooltip': {
        opacity: 1,
        visibility: 'visible',
        transform: 'translateY(0)',
      },
    },
    deliverTooltip: {
      position: 'absolute',
      bottom: 'calc(100% + 10px)',
      right: '0',
      backgroundColor: '#0F172A',
      color: '#FFFFFF',
      fontSize: '12px',
      padding: '6px 12px',
      borderRadius: '6px',
      whiteSpace: 'nowrap',
      border: '1px solid #334155',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
      pointerEvents: 'none',
      opacity: 0,
      visibility: 'hidden',
      transform: 'translateY(4px)',
      transition: 'all 0.2s ease-in-out',
      zIndex: 10,
      '&::before': {
        content: '""',
        position: 'absolute',
        top: '100%',
        right: '23px',
        borderWidth: '7px',
        borderStyle: 'solid',
        borderColor: '#334155 transparent transparent transparent',
      },
      '&::after': {
        content: '""',
        position: 'absolute',
        top: '100%',
        right: '24px',
        borderWidth: '6px',
        borderStyle: 'solid',
        borderColor: '#0F172A transparent transparent transparent',
      },
    },
    deliveryCardItem: {
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '8px 10px',
      borderRadius: '8px',
      fontSize: '12px',
    },
    deliveryLink: {
      color: '#3B82F6',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      maxWidth: '220px',
      display: 'block',
      flex: 1,
      mr: '8px',
      textDecoration: 'underline',
      '&:hover': { color: '#2563EB' },
    },
    // square slot for a row action icon so the icons line up in every row (e.g. delivery notes table)
    actionIcon: {
      width: '20px',
      height: '20px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      flexShrink: 0,
    },
    deliveryDocIcon: {
      backgroundColor: '#FEE2E2',
      color: '#DC2626',
      borderRadius: '4px',
      padding: '4px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
    },
    deliveryDeleteIcon: {
      cursor: 'pointer',
      color: '#EF4444',
      ml: '4px',
      pt: '2px',
      flexShrink: 0,
      '&:hover': { opacity: 0.8 },
    },
  },
  badges: {
    DropDownbedge: {
      border: "1px solid #F7EFE5",
      borderRadius: 20,
      position: 'absolute',
      marginTop: '10px',
      // ml: 3,
      backgroundColor: "InactiveBorder",
      color: 'secondary'
    },
    legendDot: {
      width: 10,
      height: 10,
      bg: '#ccc',
      borderRadius: 2,
      flex: '0 0 auto'
    },
    badgeCount: {
      border: "1px solid #F7EFE5",
      borderRadius: 20,
      position: 'relative',
      marginTop: '10px',
      // ml: 3,
      backgroundColor: "InactiveBorder",
      // color: 'secondary'
    },
    tradeBadge: {
      width: '42px',
      height: '42px',
      borderRadius: '10px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '16px',
      fontWeight: 700,
      cursor: 'pointer',
      userSelect: 'none',
      transition: 'all 0.15s ease-in-out',
    },
    // small count on an icon's top-right corner (e.g. attachment count in the delivery notes table)
    iconCount: {
      position: 'absolute',
      top: '-7px',
      right: 0,
      minWidth: '15px',
      height: '15px',
      px: '4px',
      borderRadius: '8px',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '10px',
      fontWeight: 600,
      lineHeight: 1,
      color: '#ffffff',
      bg: '#6366f1',
    },
  },
  links: {
    bold: {
      fontWeight: 'bold',
      color: 'primary'
    },
    nav: {
      fontWeight: 'bold',
      color: 'black',
      textDecoration: 'none',
    }
  },
  images: {
    avatar: {
      width: 48,
      height: 48,
      borderRadius: '24px',
    },
    chatAvtar: {
      width: '28px',
      height: '28px'
    },

    // avatar: {
    //   // minWidth:'39%',
    //   width: '48px',
    //   height: '48px',
    //   borderRadius: "99999",
    // },
  },

  styles: {
    Button: {
      background: 'white',
      color: '#C3ACD0'
    },
    cards: {
      primary: {
        padding: 2,
        borderRadius: 4,
        boxShadow: '0px 0px 16px 0px rgba(0, 0, 0, 0.06)',
      },
      compact: {
        padding: 1,
        borderRadius: 2,
        border: '1px solid',
        borderColor: 'muted',
      },
    },
    root: {
      fontFamily: 'Poppins'
    },
    h1: {
      fontSize: '36px',
      fontWeight: 600,
      lineHeight: '56px',
      color: '#020202',
    },
    form: {
      width: "77%",
    },
    label: {
      fontWeight: "body",
      marginTop: 3,
      fontSize: 2,
      lineHeight: "body",
    },
    input: {
      border: "1px solid",
      borderColor: "primary",
      padding: "10px 14px 10px 14px",
    },
    errorFeedback: {
      marginTop: 3,
      color: "error", // Adjust color as needed
    },
    checkboxContainer: {
      alignItems: "center",
    },
    checkboxInput: {
      marginLeft: 2,
    },
    forgotPasswordLink: {
      color: "primary",
      marginLeft: "auto",
    },
    loginButton: {
      variant: "primary",
      width: "100%",
      borderRadius: "button",
      fontSize: 2,
      marginTop: 3,
    },
    signUpText: {
      top: 3,
      position: "relative",
      display: "flex",
    },
    summaryBox: {
      gap: ["0.1rem"],
      alignItems: "center",
      border: "1px solid #8D8D8D",
      padding: ["8px 6px", "8px 6px", "8px 6px", "8px 4px"],
      borderRadius: "8px",
      fontSize: '15px',
      '@media (-webkit-min-device-pixel-ratio: 1.25), (min-resolution: 120dpi)': {
        fontSize: '13px'
      }
    }
  },
  fontWeights: {
    heading: 700,
    body: 500
  },
  lineHeights: {
    heading: '38px',
    body: '28px'
  },
  radii: {
    default: '12px',
    card: '8px',
    button: "12px"
  },
};

export default theme;
